const selectInfo = [
    {
        name:"selectMain1",
        el:"#select1-1",
    },
    {
        name:"selectMain2",
        el:"#select1-2",
    },
    {
        name:"selectSub1",
        el:"#select2-1",
    },
    {
        name:"selectSub2",
        el:"#select2-2",
    }
];

export default selectInfo;


// WEBPACK FOOTER //
// ./src/js/util/select-info.js